import { QueryClient } from 'react-query';
import { dehydrate } from 'react-query/hydration';
import { genresIdentifier, API, countriesIdentifier } from '../../api';

export const prefetchGenres = async (queryCache: QueryClient) => {
  await queryCache.prefetchQuery(genresIdentifier, API.genres.fetch);
};

export const prefetchCountries = async (queryCache: QueryClient) => {
  await queryCache.prefetchQuery(countriesIdentifier, API.countries.fetch);
};

/**
 * Create a queryCache to hydrate the frontend after SSR.
 * @param args a list of prefetch functions
 */
export const createQueryCacheState = async (
  ...args: ((queryCache: QueryClient) => Promise<void>)[]
) => {
  const queryCache = new QueryClient();
  await Promise.all(args.map((f) => f(queryCache)));
  return {
    dehydratedState: dehydrate(queryCache),
  };
};
